import $ from "jquery";

export const initSlideinBanner = () => {
    const banner = $('.slidein-banner');
    const DISMISSED_STORAGE_KEY = 'slideinBannerDismissed';
    const DESKTOP_DELAY = 10000;
    const MOBILE_DELAY = 20000;

    if (!$(banner).length || sessionStorage.getItem(DISMISSED_STORAGE_KEY) === 'true') {
        return;
    }

    const delay = window.innerWidth <= 767 ? MOBILE_DELAY : DESKTOP_DELAY;
    const showBannerTimeout = window.setTimeout(() => {
        $(banner).fadeIn();
    }, delay);

    $(banner).find('.slidein-banner__close').on('click', () => {
        window.clearTimeout(showBannerTimeout);
        $(banner).hide();
        sessionStorage.setItem(DISMISSED_STORAGE_KEY, 'true');
    });
}
